import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import Typography from "@material-ui/core/Typography";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Tooltip from "@material-ui/core/Tooltip";
import makeStyles from "@material-ui/core/styles/makeStyles";

import headerTitleStyle from "./header-title.styles";

const useStyles = makeStyles(headerTitleStyle);

function HeaderTitle({ text, backTo }) {
  const classes = useStyles();

  return (
    <div className={classes.titleWrapper}>
      {backTo === null ? null : (
        <Link to={backTo} className={classes.link}>
          <ArrowBackIcon />
        </Link>
      )}
      <Tooltip title={text} placement="bottom-start">
        <Typography variant="h5" gutterBottom className={classes.title}>
          {text}
        </Typography>
      </Tooltip>
    </div>
  );
}

HeaderTitle.propTypes = {
  text: PropTypes.string.isRequired,
  backTo: PropTypes.string,
};

HeaderTitle.defaultProps = {
  backTo: null,
};

export default HeaderTitle;
